import ModalAddGroup from 'Components/ModalAddGroup'
import {
  Flex,
  FormElement,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  Select
} from 'mailup-web-components'
import { addGroupCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

const StartTypeGroup = () => {
  const intl = useIntl()

  const { Action, IdGroup } = useRecoilValue(step2State)

  const { groups } = useRecoilValue(workflowCommonDataState)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const addGroup = useRecoilCallback(addGroupCallback, [])

  const [idGroupIsDirty, setIdGroupIsDirty] = useState(false)

  const [showAddGroupModal, setShowAddGroupModal] = useState(false)

  const handleIsIn = () => {
    setWorkflowDetailsState((prev) => ({ ...prev, Action: true }))
  }
  const handleIsNotIn = () => {
    setWorkflowDetailsState((prev) => ({ ...prev, Action: false }))
  }

  const handleChangeGroup = (value) => {
    setIdGroupIsDirty(true)
    setWorkflowDetailsState((prev) => ({ ...prev, IdGroup: value }))
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const handleAddGroup = () => {
    setShowAddGroupModal(true)
  }

  const handleModalAddGroupCancel = () => {
    setShowAddGroupModal(false)
  }

  const handleModalAddGroupConfirm = async (payload) => {
    await addGroup(payload)
    setShowAddGroupModal(false)
  }

  const AddGroupLink = () => (
    <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={handleAddGroup}>
      {intl.formatMessage({ id: 'Load.AutomationWorkflow.AddNewGroup' })}
    </Link>
  )

  return (
    <>
      <ModalAddGroup
        show={showAddGroupModal}
        onCancel={handleModalAddGroupCancel}
        onConfirm={handleModalAddGroupConfirm}
      />
      <FormElement
        label={intl.formatMessage({
          id: 'Load.AutomationWorkflow.GroupConditionExitCaption'
        })}
      >
        <Flex alignItems='center' justifyContent='flex-start' columnGap='32px'>
          <RadioButton
            label={intl.formatMessage({
              id: 'Load.AutomationWorkflow.GroupConditionEnterLabel'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            checked={Action}
            onChange={handleIsIn}
          />
          <RadioButton
            label={intl.formatMessage({
              id: 'Load.AutomationWorkflow.GroupConditionExitLabel'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            checked={!Action}
            onChange={handleIsNotIn}
          />
        </Flex>
      </FormElement>
      <FormElement
        label={intl.formatMessage({
          id: 'Load.AutomationWorkflow.GroupLabel'
        })}
        required
        feedback={idGroupIsDirty && !IdGroup ? requiredFeedback : undefined}
        variant={idGroupIsDirty && !IdGroup ? 'danger' : undefined}
        LabelRightComponent={AddGroupLink}
      >
        <Select
          value={IdGroup}
          options={groups}
          onChange={handleChangeGroup}
          placeholder={intl.formatMessage({ id: 'Load.Common.SelectGroup' })}
          error={idGroupIsDirty && !IdGroup}
        />
      </FormElement>
    </>
  )
}

export default StartTypeGroup
